import React, { ReactNode } from 'react'

import { Box } from '@mui/material'
import {
  // alpha,
  // styled,
  SxProps,
} from '@mui/material/styles'
// import SimpleBarReact from 'simplebar-react'

// ----------------------------------------------------------------------

// const RootStyle = styled('div')(() => ({
//   flexGrow: 1,
//   height: '100%',
//   overflow: 'hidden',
// }))

// const SimpleBarStyle = styled(SimpleBarReact)(({ theme }) => ({
//   maxHeight: '100%',
//   '& .simplebar-scrollbar': {
//     '&:before': {
//       backgroundColor: alpha(theme.palette.grey[600], 0.48),
//     },
//     '&.simplebar-visible:before': {
//       opacity: 1,
//     },
//   },
//   '& .simplebar-track.simplebar-vertical': {
//     width: 10,
//   },
//   '& .simplebar-track.simplebar-horizontal .simplebar-scrollbar': {
//     height: 6,
//   },
//   '& .simplebar-mask': {
//     zIndex: 'inherit',
//   },
// }))

// ----------------------------------------------------------------------

type ScrollbarPropTypes = {
  children: ReactNode
  sx?: SxProps
  className?: string
}

const Scrollbar: React.FC<ScrollbarPropTypes> = ({ children, sx, ...other }) => {
  //   const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent

  //   const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)

  //   if (isMobile) {
  return (
    <Box sx={{ overflowX: 'auto', ...sx }} {...other}>
      {children}
    </Box>
  )
  //   }

  // TODO: Fix; now simplebar placeholder dont work as shold
  //   return (
  //     <RootStyle>
  //       <SimpleBarStyle
  //         //   timeout={500}
  //         clickOnTrack={false}
  //         sx={sx}
  //         {...other}
  //       >
  //         {children}
  //       </SimpleBarStyle>
  //     </RootStyle>
  //   )
}

export default Scrollbar
